module.exports = __webpack_public_path__ + "static/pixel-art-668480e3e58a1e0364efecbe18e28c98.png";